<template>
    <!-- v-show is required to prevent CLS for ssr -->
    <div
        v-show="!$ceres.isSSR"   
        class="cookie-bar"
        :class="{
            'out': !isVisible,
            // 'border-top bg-white': isVisible,
            // 'fixed-bottom': !isShopBuilder || false
        }"
    >
        <div v-show="isVisible" class="overlay"></div>   
        <div :class="['container-max cookie-window', { 'isExpanded': isExpanded }]" v-if="isVisible" data-cookie-bar>
            <div class="py-3" v-show="!isExpanded" :class="classes" :style="styles">
                
                <div class="pb-2">
                    <div class="cookiebar-header">
                        <h3 class="cookiebar-headline">
                            <svg class="cookie-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                            </svg>
                            {{ $translate("GonserDT::Template.cookieBarHeadline") }}
                        </h3>
                        <div class="language-container">
                            <div class="dropdown">
                                <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton-cookieBar" aria-haspopup="true" aria-expanded="false">
                                    <span class="text-uppercase">{{ currentLanguage }}</span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton-cookieBar">
                                    <a
                                    v-for="langItem in languageList"
                                    :key="getLangIso(langItem) || (langItem.name || langItem)"
                                    class="dropdown-item"
                                    :href="hrefFor(langItem)"
                                    v-if="!isCurrentLanguage(langItem)"
                                    data-update-url
                                    >
                                    <span class="text-uppercase">{{ (langItem.name || langItem) }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <p v-html="text"></p>

                    <div>                     
                        <a href="#" class="d-block mb-4 cookieBarMoreSettings" data-testing="cookie-bar-show-more-information" @click.prevent.stop="isExpanded=true">{{ $translate("Ceres::Template.cookieBarMoreSettings") }}</a>
                    </div>

                </div>
                <div>
                    <button
                        class="btn btn-block btn-default btn-appearance mb-2 mt-0 accept-button"
                        @click="acceptAll(); close()"
                        data-testing="cookie-bar-accept-all">
                        {{ $translate("Ceres::Template.cookieBarAcceptAll") }}
                    </button>
                </div>

            </div>
            <div class="row py-3" v-if="isExpanded" :class="classes" :style="styles">
                <div class="col-12 mb-3">
                    <privacy-settings :consent-groups="consentGroups"></privacy-settings>
                </div>
                <div class="col-12">
                    <a
                        href="#"
                        class="text-primary text-appearance d-inline-block mb-3"
                        data-testing="cookie-bar-hide-more-information"
                        @click.prevent.stop="isExpanded = false">
                        {{ $translate("Ceres::Template.cookieBarBack") }}
                    </a>
                </div>
                <div class="col-12">
                    <div>
                        <div class="mt-2">
                           <button
                                class="btn btn-block btn-default btn-appearance"
                                @click="acceptAll(); close()"
                                data-testing="cookie-bar-expanded-accept-all">
                                {{ $translate("Ceres::Template.cookieBarAcceptAll") }}
                            </button>
                        </div>
                        <div v-if="showRejectAll" class="mt-2">
                            <button
                                class="btn btn-block btn-default btn-appearance"
                                @click="denyAll(); close()"
                                data-testing="cookie-bar-expanded-deny-all">
                                {{ $translate("Ceres::Template.cookieBarDenyAll") }}
                            </button>
                        </div>
                        <div class="mt-2">
                            <button
                                class="btn btn-block btn-default"
                                @click="storeConsents(); close()"
                                data-testing="cookie-bar-expanded-save">
                                {{ $translate("Ceres::Template.cookieBarSave") }}
                            </button>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        <div v-else>
            <button class="btn btn-primary btn-appearance" @click.prevent.stop="isCollapsed = false" :aria-label="$translate('Ceres::Template.cookieBarPrivacySettings')">
                <i class="fa fa-shield float-none"></i>
                <span class="d-none d-sm-inline-block">{{ $translate("Ceres::Template.cookieBarPrivacySettings") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import { ComponentIdMixin } from "../../mixins/componentId.mixin";

export default {
    props:
    {
        styles: String,
        classes: String,
        consentGroups: Object,
        showRejectAll: {
            type: Boolean,
            default: true
        },
        languageList: {
            type: Array,
            required: true
        },
        languageUrls: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    mixins: [ComponentIdMixin], // Experimental mixin, may be removed in the future.

    data()
    {
        return {
            isCollapsed: true,
            isExpanded: false,
        };
    },

    computed:
    {
        isVisible()
        {
            return App.isShopBuilder || !this.$store.state.consents.hasResponse || !this.isCollapsed;
        },

        isShopBuilder()
        {
            return App.isShopBuilder;
        },
        // use global window.App.language if available
        currentLanguage()
        {
            if (typeof window !== "undefined" && window.App && window.App.language) {
                return window.App.language;
            }

            // fallback to first language in list or empty
            return (this.languageList && this.languageList.length) ? this.languageList[0] : "";
        },
        currentLanguageIso() {
            if (typeof window !== "undefined" && window.App && window.App.language) {
                return String(window.App.language).toLowerCase();
            }

            // fallback: try to infer from first languageList item
            if (this.languageList && this.languageList.length) {
                const first = this.languageList[0];
                if (typeof first === 'object' && first.iso) {
                    return String(first.iso).toLowerCase();
                }
                if (typeof first === 'string') {
                    return String(first).toLowerCase().slice(0,2);
                }
            }

            return '';
        },
        // minimal normalized mapping of the server-provided prop: { 'fr': 'https://...' }
        resolvedLanguageUrls()
        {
            const out = {};
            if (!this.languageUrls) {
                return out;
            }

            Object.keys(this.languageUrls).forEach(k => {
                const lk = String(k).toLowerCase();
                const v = this.languageUrls[k];
                out[lk] = (typeof v === 'string') ? v : String(v || '');
            });

            return out;
        },

        text()
        {
            const links = {
                gtc: "<a class=\"text-appearance\" href=\"" + App.urls.gtc + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutGtc") + "</a>",
                cancellation: "<a class=\"text-appearance\" href=\"" + App.urls.cancellationRights + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutCancellationRight", {"hyphen": "&shy;"}) + "</a>",
                policy: "<a class=\"text-appearance\" href=\"" + App.urls.privacyPolicy + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"}) + "</a>",
                legal: "<a class=\"text-appearance\" href=\"" + App.urls.legalDisclosure + "\" target=\"_blank\">" + this.$translate('Ceres::Template.footerLegalDisclosure') + "</a>"
            };

            return this.$translate("Ceres::Template.cookieBarHintText", links);
        }
    },

// ...existing code...
    mounted() {
        if (typeof window === "undefined") {
            return;
        }

        try {
            if (window.jQuery && typeof window.jQuery.fn.dropdown === "function") {
                const $btn = window.jQuery(this.$el).find("#dropdownMenuButton-cookieBar");
                // ensure data-toggle exists before init
                $btn.attr("data-toggle", "dropdown");
                // initialize plugin
                $btn.dropdown();
                this._bsDropdown = $btn;
            } else {
                console.warn("CookieBar: jQuery or bootstrap dropdown plugin not available");
            }
        } catch (e) {
            console.warn("CookieBar: bootstrap dropdown init failed", e);
        }
    },

    beforeDestroy() {
        // dispose bootstrap dropdown if possible
        try {
            if (this._bsDropdown && typeof this._bsDropdown.dropdown === "function") {
                // attempt to call dispose if supported
                try { this._bsDropdown.dropdown("dispose"); } catch (e) { /* ignore */ }
            }
        } catch (e) {
            // ignore disposal errors
        }
    },

    methods:
    {
        ...mapMutations([
            "storeConsents",
            "acceptAll",
            "denyAll"
        ]),

        close()
        {
            this.isCollapsed = true;
            this.isExpanded = false;
        },

        open()
        {
            this.isCollapsed = false;
        },

        isConsented(groupKey)
        {
            return this.$store.getters.isConsented(groupKey + ".*");
        },

        toggleConsent(groupKey)
        {
            this.$store.commit("toggleConsent", groupKey + ".*");
        },

        // 1) normalize a language list item to a lowercase ISO key ("fr","en","de")
        getLangIso(langItem) {
            if (typeof langItem === 'object') {
                return String(langItem.iso || langItem.name || '').toLowerCase().slice(0,2);
            }
            return String(langItem || '').toLowerCase().slice(0,2);
        },

        // 2) return true if this langItem is the currently selected language
        isCurrentLanguage(langItem) {
            const iso = this.getLangIso(langItem);
            return iso && this.currentLanguageIso && iso === this.currentLanguageIso;
        },

        // 3) resolve the href: prefer server mapping (languageUrls prop) then fallback to path-based
        hrefFor(langItem) {
            const iso = this.getLangIso(langItem);
            const qs = (typeof window !== 'undefined' && window.location.search) ? window.location.search : '';
            const mapped = this.resolvedLanguageUrls[iso];

            if (mapped && mapped.length) {
                return mapped + qs;
            }

            // simple fallback: same-path with different leading lang
            let currentPath = '';
            if (typeof window !== 'undefined') {
                currentPath = window.location.pathname.replace(/^\/[a-zA-Z]{2}/, '');
                if (!currentPath.startsWith('/')) currentPath = '/' + currentPath;
                if (currentPath === '/') currentPath = '';
            }
            return `/${iso}${currentPath}${qs}`;
        }
    }
}
</script>
